import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * Shared page container — the single owner of every screen's outer padding and
 * max-width. AppShell's <main> carries zero padding by design (pages own their
 * own spacing), so every screen wraps its content in this instead of inventing
 * its own root wrapper. `className` is an escape hatch for the rare page that
 * needs to override the defaults.
 */
export function PageContainer({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) {
	return (
		<div className={cn('mx-auto max-w-6xl space-y-6 p-6', className)}>
			{children}
		</div>
	);
}
